import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '../../components/ui/Button'
import { LeftArrowWhite } from '../../assets/images/svg/LeftArrow'
import EmailInput from '../../components/ui/EmailInput'
import { sendEmail } from 'src/services/functionServices'
import { observer } from 'mobx-react'
import { applicationStore } from 'src/store/ApplicationStore'
import { toast } from 'react-toastify'
import Preloader from 'src/components/ui/Preloader'
import logger from 'src/utils/logger'
import { useTranslation } from 'react-i18next'

const ContinueOnAnotherDeviceEmail = observer(() => {
    const [isActive, setIsActive] = useState(false)
    const [value, setValue] = useState(null)
    const [submitting, setSubmitting] = useState(false)
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleSendEmail = async () => {
        try {
            setSubmitting(true)
            await sendEmail(value, applicationStore.access_token)
            toast.success(t('confirmEmail.emailSent'))
            applicationStore.setContinueOnAnotherDeviceSmsOrEmail("/continue-on-another-device-email")
            navigate("/check-your-device", { replace: true, state: { value } })
        } catch (error) {
            logger.log(error);
            toast.error(t('confirmEmail.emailNotSent'))
        } finally {
            setSubmitting(false)
        }
    }

    return (
        <div className="custom-container">
            <div className="flex justify-between flex-col items-center h-full">
                <div>
                    <div className='text-left'>
                        <Button className="" variant="primaryBack" onClick={() => { navigate("/continue-on-another-device", { replace: true }) }}><LeftArrowWhite /></Button>
                    </div>
                    <div className='grid gap-[16px] mt-10'>
                        <div className="text-h5 font-bold text-flow-heading">{t('continueAnother.title')}</div>
                        <div className="text-body text-Gray900">{t('continueAnother.description.email')}</div>
                    </div>
                    <div className='mt-10'>
                        <div className='text-left mb-1'>
                            <span className='text-xs text-Gray900'>{t('continueAnother.emailLabel')}</span>
                        </div>
                        <EmailInput setIsActive={setIsActive} setValue={setValue} />
                    </div>
                    <div className='mt-6'>
                        <Button className="" variant="primaryWithoutIcon" disabled={!isActive || submitting} onClick={handleSendEmail}>
                            <span className="me-1">{t('continueAnother.sendSecureLink')}</span>{submitting && <Preloader variant='white' />}
                        </Button>
                    </div>
                </div>
                <div className="">

                </div>
            </div>
        </div>
    )
})

export default ContinueOnAnotherDeviceEmail
